import { defineMessages } from 'react-intl';

const messages = defineMessages({
  singleOrderWarning: {
    description: 'customs.status.warning.singleOrderWarning',
    defaultMessage:
      'Currency of the order is {currencyList}. Customs value currency is {customsCurrencyCode}. Please double check for conversion accuracy.',
    id: 'ViZ/FS',
  },
  multiOrderMultiCurrencyWarning: {
    description: 'customs.status.warning.multiOrderMultiCurrencyWarning',
    defaultMessage:
      'One or more orders being shipped are in {currencyList}. Customs value currency is {customsCurrencyCode}. Please double check for conversion accuracy.',
    id: '+9YsRb',
  },
  multiOrderSingleCurrencyWarning: {
    description: 'customs.status.multiWarning',
    defaultMessage:
      'One or more orders being shipped are not in {customsCurrencyCode}. Customs value currency is {customsCurrencyCode}. Please double check for conversion accuracy.',
    id: '+hXFGO',
  },
});

export default messages;
